import L from 'leaflet';
import Icons from '../Assets/SZNOIcons.js';
import RoomIcon from '@mui/icons-material/Room';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import { styled } from '@mui/system';

const defaultIcon = new L.Icon({
    iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',  
    iconSize: [25, 41],  
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
  });

  const {
    apartmentIcon, bedandbreakfastIcon, bedandbreakfastfoodIcon, hostelIcon, udvarhazIcon, campingIcon, tentandcampingIcon,
    chapelIcon, churchIcon, varIcon, borvizIcon, forrasIcon, hotspringIcon, hotelIcon, hotel3starIcon, hotel4starIcon, mineIcon,
    mineclosedIcon, oilandgaswellIcon, oilpumpjackIcon, panoramicviewIcon, sizesIcon, siberlesIcon, sifelvonoIcon, iszapvulkanIcon,
    strandIcon, castleIcon, uszodaIcon, uszasIcon, satrazasIcon,  motelIcon, peakIcon, mofettaIcon, radioactivIcon, kenesIcon,
    kakasborozdaIcon, letelepedesIcon, regeszIcon, rovasemlekIcon, sipalyaIcon, skiIcon, stranduszodaIcon,
    brokenPotteryIcon, runestoneIcon, villageIcon,
  } = Icons;

  const RoomIcons = {
    RoomIcon,
    RedRoomIcon: styled(RoomIcon)({ color: 'red' }),
    GreenRoomIcon: styled(RoomIcon)({ color: 'green' }),
    YellowRoomIcon: styled(RoomIcon)({ color: 'yellow' }),
    OrangeRoomIcon: styled(RoomIcon)({ color: 'orange' }),
    csangoTelepulesIcon: villageIcon,
    defaultIcon,
  };

  export const IconsList = {
    apartmentIcon, bedandbreakfastIcon, bedandbreakfastfoodIcon, hostelIcon, udvarhazIcon, campingIcon, tentandcampingIcon,
    chapelIcon, churchIcon, varIcon, borvizIcon, forrasIcon, hotspringIcon, hotelIcon, hotel3starIcon, hotel4starIcon, mineIcon,
    mineclosedIcon, oilandgaswellIcon, oilpumpjackIcon, panoramicviewIcon, sizesIcon, siberlesIcon, sifelvonoIcon, iszapvulkanIcon,
    strandIcon, castleIcon, uszodaIcon, uszasIcon, satrazasIcon,  motelIcon, peakIcon, mofettaIcon, radioactivIcon, kenesIcon,
    kakasborozdaIcon, letelepedesIcon, regeszIcon, rovasemlekIcon, sipalyaIcon, skiIcon, stranduszodaIcon,
    brokenPotteryIcon, runestoneIcon, villageIcon, csangoTelepulesIcon: villageIcon
  };
  

export function IconDisplay(iconType) {
    switch (iconType) {
        case 'szanto':
            return hostelIcon;
        case 'beltelek':
        case 'kaszalo':
        case 'erdo':
        case 'garzon':
        case 'csaladihaz':
        case 'hetvegihaz':
        case 'kulcsoshaz':      
        case 'iroda':
        case 'ipari epulet':
        case 'kereskedelmi ingatlan':
        case 'ingatlan':
        case 'Ingatlan':
        case 'egyeb':
            return RoomIcons.RoomIcon;
        case 'auto':
        case 'Auto':
            return RoomIcons.RedRoomIcon;
        case 'telisportfelszereles':
        case 'Telisportfelszereles':
            return RoomIcons.GreenRoomIcon;
        case 'nyarisportfelszereles':
        case 'Nyarisportfelszereles':
            return RoomIcons.YellowRoomIcon;
        case 'sajattermek':
        case 'Sajattermek':
            return RoomIcons.OrangeRoomIcon;
        case 'hosztel':
        case 'Hosztel':
            return hostelIcon;
        case 'udvarhaz':
        case 'Udvarhaz':
            return udvarhazIcon;
        case 'kastely':
        case 'Kastely':
            return castleIcon;
        case 'hotel':
        case 'Hotel':
            return hotelIcon;
        case 'panzio':
        case 'Panzio':
            return bedandbreakfastIcon;
        case 'kiadoszoba':
        case 'Kiadoszoba':
            return bedandbreakfastfoodIcon;
        case 'tombhazlakas':
        case 'Tombhazlakas':
            return apartmentIcon;
        case 'szallasreggelivel':
        case 'Szallasreggelivel':
            return bedandbreakfastfoodIcon;
        case 'kemping':
        case 'Kemping':
            return campingIcon;
        case 'satorozas':
        case 'Satorozas':
            return tentandcampingIcon;
        case 'kapolna':
        case 'Kapolna':
            return chapelIcon;
        case 'templom':
        case 'Templom':
            return churchIcon;
        case 'var':
        case 'Var':
            return varIcon;
        case 'borviz':
        case 'Borviz':
            return borvizIcon;
        case 'forras':
        case 'Forras':
            return forrasIcon;
        case 'thermalforras':
        case 'termalforras':
        case 'Termalforras':
        case 'termalviz':
        case 'Termalviz':
            return hotspringIcon;
        case 'mofetta':
        case 'Mofetta':
            return mofettaIcon;
        case 'radioaktiv':
        case 'Radioaktiv':
            return radioactivIcon;
        case 'kenes':
        case 'Kenes':
            return kenesIcon;
        case 'hotel***':
            return hotel3starIcon;
        case 'hotel****':
            return hotel4starIcon;
        case 'banya':
        case 'Banya':
            return mineIcon;
        case 'zartbanya':
        case 'Bezartbanya':
            return mineclosedIcon;
        case 'olajesgazkut':
        case 'Olajesgaz':
            return oilandgaswellIcon;
        case 'olajpumpa':
            return oilpumpjackIcon;
        case 'panorama':
        case 'Kilato':
            return panoramicviewIcon;
        case 'sizes':
        case 'Sizes':
            return sizesIcon;
        case 'sifelvono':
        case 'Sifelvono':
            return sifelvonoIcon;
        case 'siberles':
        case 'Siberles':
            return siberlesIcon;
        case 'iszapvulkan':
        case 'Iszapvulkan':
            return iszapvulkanIcon;
        case 'strand':
        case 'Strand':
            return strandIcon;
        case 'uszoda':
        case 'Uszoda':
            return uszodaIcon;
        case 'uszas':
        case 'Uszas':
            return uszasIcon;
        case 'SkiArea':
        case 'SkiLine':
        case 'Ski':
        case 'Sipalya':
            return sizesIcon;
        case 'StrandUszoda':
            return strandIcon;
        case 'Regesz':
            return brokenPotteryIcon;
        case 'Rovasemlek':
            return runestoneIcon;
        case 'Kakasborozda':
            return kakasborozdaIcon;
        case 'Letelepedes':
            return letelepedesIcon;
        case 'Kofejto':
            return mineIcon;
        case 'satortabor':
            return satrazasIcon;
        case 'motel':
            return motelIcon;
        case 'csucs':
            return peakIcon;
        case 'Pension':
        case 'Panzio':
            return bedandbreakfastIcon;
        case 'Guesthouse':
        case 'Kulcsoshaz':
            return udvarhazIcon;
        case 'Barn':
        case 'Csur':
            return satrazasIcon;
        case 'Camping':
        case 'Satorhely':
            return campingIcon;
        default:
            return null; 
    }
}

export { Icons, RoomIcons };